module.exports = __webpack_public_path__ + "img/electricityMeterBoxImages-example.b965cc68.jpg";